module.exports = __webpack_public_path__ + "img/2.ff6dbc78.png";